export default "/bundles/assets/attachment_pdf_9cf129a9edd0e5bed16b007de0d67a1f.png";